<template>
  <div class="container mx-auto px-4 h-full">
    <div class="flex content-center items-center justify-center h-full">
      <div class="w-full lg:w-8/12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0"
        >
          <div class="rounded-t mb-0 px-6 py-6">
            <hr class="mb-6 border-b-1 border-blueGray-300" />
            <div class="text-center mb-3">
              <h6 class="text-blueGray-500 text-md font-bold">
                ACCOUNT ENROLLMENT
              </h6>
            </div>
            <hr class="mt-6 border-b-1 border-blueGray-300" />
          </div>
          <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
            <div class="text-blueGray-400 text-center mb-3 font-bold"></div>
            <form @submit.prevent="submitForm">
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  First Name
                  <span class="text-red-500">*</span>
                </label>

                <input
                  v-model="formData.first_name"
                  type="text"
                  maxlength="20"
                  @input="restrictToAlpha('first_name')"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="First Name"
                  name="first_name"
                />
                <span
                  v-if="!formData.first_name.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >First Name is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Middle Name
                  <span class="text-red-500">*</span>
                </label>

                <input
                  v-model="formData.middle_name"
                  type="text"
                  maxlength="20"
                  @input="restrictToAlpha('middle_name')"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="First Name"
                  name="middle_name"
                />
                <span
                  v-if="!formData.middle_name.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Middle Name is required</span
                >
              </div>
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Last Name
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.last_name"
                  type="text"
                  maxlength="20"
                  @input="restrictToAlpha('last_name')"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Last Name"
                  name="last_name"
                />
                <span
                  v-if="!formData.last_name.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Last Name is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Date of Birth
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.date_of_birth"
                  type="date"
                  :max="maxDob"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="mm/dd/yyyy"
                  name="regionl_center"
                />
                <span
                  v-if="!formData.date_of_birth.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Date of Birth is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Gender
                  <span class="text-red-500">*</span>
                </label>
                <div class="flex items-center space-x-6">
                  <label class="inline-flex items-center">
                    <input
                      type="radio"
                      v-model="formData.gender"
                      value="Male"
                      class="form-radio text-blue-500"
                    />
                    <span class="ml-2 mr-2 text-blueGray-600 text-md"
                      >Male</span
                    >
                  </label>
                  <label class="inline-flex items-center">
                    <input
                      type="radio"
                      v-model="formData.gender"
                      value="Female"
                      class="form-radio text-emerald-400"
                    />
                    <span class="ml-2 text-blueGray-600 text-md">Female</span>
                  </label>
                </div>
                <span
                  v-if="!formData.gender && validation_fail"
                  class="text-red-500 text-md"
                  >Gender is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Address
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.address"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Address"
                  name="address"
                />
                <span
                  v-if="!formData.address.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Address is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  City
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.city"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="City"
                  name="city"
                />
                <span
                  v-if="!formData.city.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >City is required</span
                >
              </div>
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  State
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.state"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="State"
                  name="state"
                />
                <span
                  v-if="!formData.state.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >State is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Zip Code
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.zip_code"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Zip Code"
                  name="zip_code"
                />
                <span
                  v-if="!formData.zip_code.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Zip Code is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Email
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.email"
                  type="email"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Email"
                  name="email"
                />
                <span
                  v-if="!formData.email.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Email is required</span
                >
                <span
                  v-if="formData.email.trim() && !isValidEmail(formData.email)"
                  class="text-red-500 text-md"
                  >Enter a valid email address</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Contact Number
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.contact_number"
                  type="text"
                  inputmode="numeric"
                  @input="restrictToDigits('contact_number')"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Name"
                  name="contact_number"
                />
                <span
                  v-if="!formData.contact_number.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Contact Number is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  UCI Number
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.uci_number"
                  type="text"
                  maxlength="7"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="UCI Number"
                  name="uci_number"
                />
                <span
                  v-if="!formData.uci_number.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >UCI number is required</span
                >
                <span
                  v-if="
                    formData.uci_number.length < 7 &&
                    formData.uci_number.trim().length > 0
                  "
                  class="text-red-500 text-md"
                  >UCI number must be atleast 7 characters alphanumeric</span
                >
                <span
                  v-if="
                    formData.uci_number.length > 7 &&
                    formData.uci_number.trim().length > 0
                  "
                  class="text-red-500 text-md"
                  >UCI number must not be more than 7 characters
                  alphanumeric</span
                >
              </div>
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  SS NUMBER
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-mask="'###-##-####'"
                  v-model="formData.ss_number"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="SS Number"
                  name="ss_number"
                />
                <span
                  v-if="!formData.ss_number.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >SS number is required</span
                >
                <span
                  v-if="
                    formData.ss_number.length < 11 &&
                    formData.ss_number.trim().length > 0
                  "
                  class="text-red-500 text-md"
                  >SS number must be atleast 9 characters alphanumeric</span
                >
                <span
                  v-if="
                    formData.ss_number.length > 11 &&
                    formData.ss_number.trim().length > 0
                  "
                  class="text-red-500 text-md"
                  >SS number must not be more than 9 characters
                  alphanumeric</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Regional Center Name
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.regional_center"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Regional Center Name"
                  name="regionl_center"
                />
                <span
                  v-if="!formData.regional_center.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Regional Center Name is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Regional Center Coordinator
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.regional_center_coordinator"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Regional Center Coordinator"
                  name="text"
                />
                <span
                  v-if="
                    !formData.regional_center_coordinator.trim() &&
                    validation_fail
                  "
                  class="text-red-500 text-md"
                  >Coordinator is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Regional Center Coordinator Email
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.coordinator_email"
                  type="email"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Regional Center Coordinator"
                  name="text"
                />
                <span
                  v-if="!formData.coordinator_email.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Coordinator is required</span
                >
                <span
                  v-if="
                    formData.coordinator_email.trim() &&
                    !isValidEmail(formData.coordinator_email)
                  "
                  class="text-red-500 text-md"
                  >Enter a valid email address</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Regional Center Coordinator Number
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.coordinator_number"
                  type="text"
                  inputmode="numeric"
                  @input="restrictToDigits('coordinator_number')"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Regional Center Coordinator"
                  name="text"
                />
                <span
                  v-if="!formData.coordinator_number.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Coordinator is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Password
                  <span class="text-red-500">*</span>
                </label>
                <div class="relative">
                  <input
                    v-model="formData.password"
                    :type="showPassword ? 'text' : 'password'"
                    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Password"
                    name="password"
                  />
                  <button
                    type="button"
                    class="button mt-2"
                    @click="togglePasswordVisibility"
                  >
                    <span class="icon is-small is-right text-md">
                      <i
                        class="fas"
                        :class="{
                          'fa-eye-slash': showPassword,
                          'fa-eye': !showPassword,
                        }"
                      ></i>
                      Show Password
                    </span>
                  </button>
                </div>
                <span
                  v-if="!formData.password.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Password is required</span
                >
                <span
                  v-if="
                    formData.password.length < 8 && formData.password.trim()
                  "
                  class="text-red-500 text-md"
                  >Password should contain minimum of 8 characters</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Retype Password
                  <span class="text-red-500">*</span>
                </label>
                <div class="relative">
                  <input
                    v-model="formData.password_confirm"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder=" Retype Password"
                    name="password_confirm"
                  />
                  <button
                    type="button"
                    class="button mt-2"
                    @click="toggleConfirmPasswordVisibility"
                  >
                    <span class="icon is-small is-right text-md">
                      <i
                        class="fas"
                        :class="{
                          'fa-eye-slash': showConfirmPassword,
                          'fa-eye': !showConfirmPassword,
                        }"
                      ></i>
                      Show Password
                    </span>
                  </button>
                </div>
                <span
                  v-if="
                    formData.password !== formData.password_confirm &&
                    formData.password_confirm.length > 0
                  "
                  class="text-red-500 text-md"
                  >Password did not match.</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  DMV ID or Passort ID
                  <span class="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  @change="handleFileUpload($event, 1)"
                  class="border border-blueGray-200 rounded px-3 py-2 w-full text-sm"
                />
                <span
                  v-if="!formData.valid_id_1 && validation_fail"
                  class="text-red-500 text-md"
                  >Valid ID 1 is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Social Security ID
                  <span class="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  @change="handleFileUpload($event, 2)"
                  class="border border-blueGray-200 rounded px-3 py-2 w-full text-sm"
                />
                <span
                  v-if="!formData.valid_id_2 && validation_fail"
                  class="text-red-500 text-md"
                  >Valid ID 2 is required</span
                >
              </div>

              <div>
                <label class="inline-flex items-center cursor-pointer">
                  <input
                    v-model="agreeToPrivacyPolicy"
                    id="customCheckLogin"
                    type="checkbox"
                    class="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150"
                  />
                  <span class="ml-2 text-md font-semibold text-blueGray-600">
                    I agree with the
                    <a href="javascript:void(0)" class="text-emerald-500">
                      Privacy Policy
                    </a>
                  </span>
                  <span class="text-red-500">*</span>
                </label>
              </div>
              <span
                v-if="!agreeToPrivacyPolicy && validation_fail"
                class="text-red-500 text-md"
                >Please agree to the Privacy Policy</span
              >
              <div class="text-center mt-6">
                <button
                  class="bg-blueGray-800 text-white active:bg-blueGray-600 text-md font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  type="submit"
                >
                  Create Account
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.min.css";

export default {
  data() {
    return {
      step: 1,
      formData: {
        first_name: "",
        last_name: "",
        middle_name: "",
        ss_number: "",
        uci_number: "",
        regional_center: "",
        regional_center_coordinator: "",
        gender: "",
        valid_id_1: null,
        valid_id_2: null,
        date_of_birth: "",
        address: "",
        city: "",
        state: "",
        zip_code: "",
        contact_number: "",
        email: "",
        password: "",
        coordinator_email: "",
        coordinator_number: "",
        password_confirm: "",
      },
      agreeToPrivacyPolicy: false,
      validation_fail: false,
      showPassword: false,
      showConfirmPassword: false,
    };
  },
  computed: {
    formIsValid() {
      return (
        this.agreeToPrivacyPolicy &&
        this.formData.first_name.trim() !== "" &&
        this.formData.last_name.trim() !== "" &&
        this.formData.regional_center.trim() !== "" &&
        this.formData.regional_center_coordinator.trim() !== "" &&
        this.formData.ss_number.trim() !== "" &&
        this.formData.ss_number.trim().length > 10 &&
        this.formData.ss_number.trim().length < 12 &&
        this.formData.uci_number.trim() !== "" &&
        this.formData.uci_number.trim().length > 6 &&
        this.formData.uci_number.trim().length < 8 &&
        this.formData.address.trim() !== "" &&
        this.formData.city.trim() !== "" &&
        this.formData.state.trim() !== "" &&
        this.formData.zip_code.trim() !== "" &&
        this.formData.contact_number.trim() !== "" &&
        this.formData.email.trim() !== "" &&
        this.isValidEmail(this.formData.email) &&
        this.isValidEmail(this.formData.coordinator_email) &&
        this.formData.password.length >= 8
      );
    },
    maxDob() {
      return new Date().toISOString().split("T")[0];
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    restrictToAlpha(field) {
      this.formData[field] = this.formData[field]
        .replace(/[^a-zA-Z\s'-]/g, "")
        .slice(0, 20);
    },
    restrictToDigits(field) {
      this.formData[field] = this.formData[field].replace(/\D/g, "");
    },
    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    },
    handleFileUpload(event, index) {
      const file = event.target.files[0];
      if (index === 1) {
        this.formData.valid_id_1 = file;
      } else {
        this.formData.valid_id_2 = file;
      }
    },
    async submitForm() {
      if (this.formIsValid) {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false,
          didOpen: () => Swal.showLoading(),
        });
        try {
          const payload = new FormData();
          for (const key in this.formData) {
            if (this.formData[key] !== null && this.formData[key] !== undefined) {
              payload.append(key, this.formData[key]);
            }
          }
          const response = await axios.post(
            `${process.env.VUE_APP_BACKEND_DOMAIN}/api/create_client`,
            payload
          );
          Swal.close();

          if (response.data.status === 200) {
            Swal.fire({
              title: "Registration was submitted",
              icon: "success",
            }).then(() => {
              this.$router.push({ path: "/auth/login" });
            });
          } else {
            Swal.fire({ title: response.data.errors, icon: "error" });
          }
        } catch (error) {
          Swal.close();
          let errorMsg = "An error occurred. Please try again.";
          if (error.response && error.response.data && error.response.data.errors) {
            errorMsg = Object.values(error.response.data.errors).flat().join(" ");
          } else if (error.message) {
            errorMsg = error.message;
          }
          Swal.fire({ title: errorMsg, icon: "error" });
        }
      } else {
        this.validation_fail = true;
      }
    },
  },
};
</script>
